<template>
  <IvrLayout title="電話自動受付予約（IVR）設定" showBack :onHome="back" :loading="busy">
    <ConfigPage title="利用実績" :gap="10" scrollable>
      <p>
        選択した年のIVRの利用実績が表示されます。<br />
        IVRの利用を停止されている場合も回線への架電数はカウントされます。
      </p>
      <YearNavi :selectedYear="date" @createYearData="createYearData" />
      <DataTable
        :data="ivrPerformanceList.performance"
        :minItemHeight="40"
        key-field="month"
        :columns="[
          { key: 'month', name: '月', format: month => `${month}月` },
          { key: 'receive', name: '架電数' },
          { key: 'hangup', name: '切電数' },
          { key: 'busy', name: '話中数' },
          { key: 'call', name: '通話数' },
          { key: 'reservation', name: 'IVR予約数' },
        ]"
      />
    </ConfigPage>
  </IvrLayout>
</template>

<script>
import { mapState } from 'vuex'
import IvrLayout from '@/components/templates/IvrLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import YearNavi from '@/components/molecules/YearNavi'
import DataTable from '@/components/molecules/DataTable'

export default {
  name: 'IvrDownload',
  components: {
    IvrLayout,
    ConfigPage,
    YearNavi,
    DataTable,
  },
  data() {
    return {
      date: new Date().getFullYear(),
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.users.current.user,
      ivrPerformanceList: state => state.ivr.list.ivrPerformanceList,
      busy: state => state.ivr.list.busy,
    }),
  },
  async created() {
    await this.fetch()
  },
  methods: {
    async fetch() {
      await this.$store.dispatch('ivr/list/getPerformance', this.date)
    },
    createYearData(year) {
      this.date = year
      this.fetch()
    },
    back() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="postcss" scoped>
>>> th:not(:last-child) {
  border-right: 1px solid var(--dark-gray);
}

>>> td {
  justify-content: center;
  padding: 0;

  &:not(:last-child) {
    border-right: 1px solid var(--very-light-gray);

    &::after {
      content: none;
    }
  }
}

>>> .month {
  width: 70%;
}

>>> .button {
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px auto 0;
  width: 200px;
}

.icon {
  fill: var(--white);
  margin-right: 8px;
}
</style>
